
export function formatDate(date = new Date(), format = 'DD.MM.YYYY') {
   if (typeof date === 'number') {
      date = new Date(date)
   }

   const day = date.getDate().toString().padStart(2, '0')
   const month = (date.getMonth() + 1).toString().padStart(2, '0')
   const year = date.getFullYear()
   const shortYear = year.toString().slice(-2)

   return format
      .replace('YYYY', year)
      .replace('YY', shortYear)
      .replace('MM', month)
      .replace('DD', day)
      .replace('M', (date.getMonth() + 1).toString())
      .replace('D', date.getDate().toString())
}

const minusHours = 3 * 60 * 60 * 1000 // 3 часа  в миллисекундах
const oneDay = 24 * 60 * 60 * 1000 // 24 часа в миллисекундах

export function getDateString(params = {}) {
   let date = Date.now() - minusHours
   if (params.index > 1) {
      date -= oneDay
   }
   return formatDate(date, params.format)
}